/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Owais Bakaliya",
  title: "Hi all, I'm Owais",
  subTitle: emoji(
    "A passionate Software Engineer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / Java and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1aeVQTsUpypOb5y9intyeYZUt3lwvbrE6/view", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/obakaliya",
  linkedin: "https://www.linkedin.com/in/owaisbakaliya/",
  gmail: "owaisbakaliya@gmail.com",
  stackoverflow: "https://stackoverflow.com/",
  twitter: "https://x.com/Owais_Bakaliya",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "ENTHUSIASTIC SOFTWARE ENGINEER WITH A PASSION FOR EXPLORING A DIVERSE RANGE OF TECH STACKS",
  skills: [
    emoji(
      "⚡ Develop highly interactive Frontend and Backend / User Interfaces for your web and desktop applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql / nosql - database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Illinois at Chicago",
      logo: require("./assets/images/University_of_Illinois_at_Chicago_circle_logo.svg.png"),
      subHeader: "Bachelor of Science in Computer Science and Engineering",
      duration: "August 2021 - May 2025",
      desc: "Participated in monthly hackathons and achieved an unprecedented feat by winning the first prize three times in a row with incredible projects",
      descBullets: [
        "Showcased a remarkable ability to ideate, collaborate, and execute under time constraints, a crucial skill in hackathon environments",
        "Set a remarkable record by achieving an unprecedented hat-trick of wins, highlighting dedication and excellence"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineering Intern",
      company: "PwC",
      companylogo: require("./assets/images/pwc.png"),
      date: "Jun 2024 – Aug 2024",
      desc: "Developed and maintained single SPA applications using React.js, Angular, and TypeScript, ensuring seamless user interaction and experience. Collaborated with cross-functional teams to design and implement new features, enhancing application functionality and performance. Conducted code reviews and implemented best practices to ensure code quality and maintainability, optimizing application performance and user experience."
    },
    {
      role: "Full Stack Developer",
      company: "UIC - College of Engineering Administration",
      companylogo: require("./assets/images/University_of_Illinois_at_Chicago_circle_logo.svg.png"),
      date: "Oct 2023 – Jun 2024",
      desc: "Developed a full stack application specifically for the College of Engineering faculty and staff, significantly enhancing their user experience. Integrated new features into an existing application, using comprehensive full stack frameworks to ensure seamless functionality and user interaction. Implemented robust security measures by incorporating Shibboleth SSO and JWT for secure authentication and authorization, prioritizing data protection and user privacy."
    },
    {
      role: "JP Morgan Software Engineering Virtual Experience",
      company: "JP Morgan",
      companylogo: require("./assets/images/jpmorgan.jpeg"),
      date: "Jun 2022 – Jully 2022",
      desc: "The software engineering internship at J.P. Morgan Chase was transformative. I applied skills in Python, Git, React, and TypeScript to solve real-world challenges, like visualizing trading dashboard data. Global collaboration on open-source projects and valuable mentorship culminated in a completion certificate, enhancing my skills and confidence for a promising career ahead."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle:
    "HERE ARE FEW PERSONAL PROJECTS I'VE CRAFTED DURING MY SPARE TIME, AIMING TO ENHANCE MY OWN LIFE WHILE SIMULTANEOUSLY CONTRIBUTING TO THE WELLBEING OF OTHERS.",
  projects: [
    {
      image: require("./assets/images/JobFit-Analyzer-Logo.png"),
      projectName: "JobFit Analyzer",
      projectDesc:
        "JobFit-Analyzer is a web application that helps job seekers analyze their resumes against job descriptions, providing a suggestion and a percentage match to show how well their resume aligns with the specific job they are interested in. The application is built using the MERN stack (MongoDB, Express.js, React.js, and Node.js) and utilizes JSON Web Tokens (JWT) for user authentication.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://jobfitanalyzer.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Mini-Search-Engine.png"),
      projectName: "Mini Search Engine",
      projectDesc:
        "A program that can search for queries and provide relevant URLs is a useful tool for finding information on the internet. This type of program, also known as a search engine, allows users to enter a query using keywords, phrases, or other search terms, and provides a list of relevant URLs that match the query.",
      footerLink: [
        {
          name: "Configuration Details",
          url: "https://github.com/UBakaliya/Mini-Search-Engine/tree/main"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        // },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        // {name: "Certification", url: ""},
        // {
        //   name: "Final Project",
        //   url: "https://pakistan-olx-1.firebaseapp.com/"
        // }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+0000000000",
  email_address: "owaisbakaliya@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "bigbakaliya001", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
